const careSources = [
  {id: 1, name: "Tele", key: "1", label: "Tele", unaccent_name: "tele"},
  {id: 2, name: "CS", key:"2", label: "CS", unaccent_name: "cs"},
  {id: 3, name: "KDS", key:"3", label: "KDS", unaccent_name: "kds"},
  {id: 4, name: "SM", key:"4", label: "S&M", unaccent_name: "sm"},
]

const findCareSource = (name) => careSources.find(r => r.name === name)
export {
  careSources,
  findCareSource
}